<template>
  <ResourceTile :title="title" :href="href" class="cms-tile">
    <CmsImg :src="src" ref="tileImage" />
  </ResourceTile>
</template>

<script setup lang="ts">
import { computed, provide, ref, onMounted } from "vue";
import cms from "../../services/cms/cms";
import { CmsImage, CmsResourceRelationship } from "../../services/cms/cms-type-definitions";
import CmsImg from "./cms-img.vue";
import ResourceTile from "./resource-tile.vue";

const props = defineProps<{
  link: CmsResourceRelationship | undefined;
}>();

const tileImage = ref<InstanceType<typeof CmsImg> | null>(null);
provide("cmsTileImage", tileImage);

const href = computed(() => {
  if (!props.link) {
    return null;
  }
  return cms.linkResolver(props.link);
});

const title = computed(() => {
  if (!props.link) {
    return null;
  }

  return cms.asText(props.link.data?.tile_title).trim() || cms.asText(props.link.data?.title);
});

const src = computed<CmsImage | undefined>(() => {
  if (!props.link) {
    return undefined;
  }
  return props.link.data?.title_image?.tile || props.link.data?.title_image;
});
</script>
